import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { IResponse } from '@interfaces/index';
import { IBasic, IProfessional, IQuestion } from 'projects/ui-components/src/interfaces/IProfile';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  constructor(
    protected _http_service: HttpService
  ) { }

  exportData(person_id?: number): Observable<Blob> {
    return this._http_service.download('persons/export', { person_id })
  }

  deleteAccount(): Observable<IResponse<null>> {
    return this._http_service.post('persons/delete', {})
  }

  getBasic(person_id?: number): Observable<IResponse<IBasic>> {
    return this._http_service.post('persons/get-basic', {
      person_id
    })
  }

  updateBasic(values: IBasic):Observable<IResponse<IBasic>> {
    return this._http_service.post('persons/update-basic', values)
  };

  getPersonal(person_id?: number): Observable<IResponse<IQuestion[]>> {
    return this._http_service.post('profile/get-personal', { person_id })
  }

  updatePersonal(answers: IQuestion, person_id?: number):Observable<IResponse<IQuestion[]>> {
    return this._http_service.post('profile/update-personal', {answers, person_id})
  }
  
  getPersonalConsent(person_id?: number): Observable<IResponse<{ consent: boolean }>> {
    return this._http_service.post('profile/get-personal-consent', { person_id })
  }

  updatePersonalConsent(consent: boolean): Observable<IResponse<{ consent: boolean }>> {
    return this._http_service.post('profile/update-personal-consent', { consent })
  }

  getExperience(person_id?: number): Observable<IResponse<IQuestion[]>> {
    return this._http_service.post('profile/get-experience', { person_id })
  }

  updateExperience(answers: IQuestion, person_id?: number):Observable<IResponse<IQuestion[]>> {
    return this._http_service.post('profile/update-experience', {answers, person_id})
  }

  getProfessional(person_id?: number): Observable<IResponse<IProfessional>> {
    return this._http_service.post('profile/get-professional', { person_id })
  }

  updateProfessional(values: IProfessional):Observable<IResponse<IProfessional>> {
    return this._http_service.post('profile/update-professional', values)
  };

}